var url = "";
if (window.location.host === "star-omanstg-qr-code-app.nuviotech.co") {
  url = "https://star-omanstg-api.nuviotech.co";
} else {
  // url = 'http://localhost:3800'
  url = "https://star-omanstg-api.nuviotech.co";
}
export const URL_BASE = url;



// WEBPACK FOOTER //
// ./src/helper/constants.js